import { mbToBytes } from '../units';

export const maximumImageSize = 30 * mbToBytes;